import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import Modal from 'react-responsive-modal'
import classNames from 'classnames'

export default class BackofficeDocumentsReview extends Component {
  static propTypes = {
    onRowSelected: PropTypes.func.isRequired,
    selectedRows: PropTypes.array.isRequired,
    onDocumentPreviewClick: PropTypes.func.isRequired,
    onDocumentDownloadClick: PropTypes.func.isRequired,
    mark: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDocumentApprovationChange: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      columns: [
        {
          Header: (
            <div className="documents-browser-header-list">
              Tipo
            </div>
          ),
          className: 'no-horizontal-border',
          accessor: 'DocumentType.name',
          filterable: true,
          sortable: true,
          width: 400,
          filterMethod: (filter, row) => (row[filter.id].toLowerCase().includes(filter.value.toLowerCase())),
          Cell: row => {
            const isActive = row && this.props.selectedRows.indexOf(row.index) !== -1
            return (
              <div className={classNames('documents-browser-file-cell', {'white-text': isActive})}>
                {row.value}
              </div>
            )
          }
        },
        {
          Header: (
            <div className="documents-browser-header-list">
              Approvazione
            </div>
          ),
          width: 250,
          className: 'no-horizontal-border',
          accessor: 'approved',
          filterable: false,
          sortable: true,
          Cell: row => {
            const isActive = row && this.props.selectedRows.indexOf(row.index) !== -1
            return (
              <div className={classNames('documents-browser-file-cell', {'white-text': isActive})}>
                {row.value ? (
                  <span>
                    <span className="text-success" style={{marginRight: '10px'}}>Approvato</span>
                    <a
                      className="btn-download-user"
                      onClick={() => this.props.onDocumentApprovationChange(row.original)}
                    >
                      Rimuovi Approvazione
                    </a>
                  </span>
                ) : (
                  <span>
                    <span className="text-danger" style={{marginRight: '10px'}}>Non Approvato</span>
                    <a
                      className="btn-download-user"
                      onClick={() => this.props.onDocumentApprovationChange(row.original)}
                    >
                      Approva
                    </a>
                  </span>
                )}
              </div>
            )
          }
        }
      ]
    }
  }

  render () {
    const {
      onRowSelected,
      selectedRows,
      onDocumentPreviewClick,
      onDocumentDownloadClick,
      // documents,
      loading,
      error,
      open,
      onClose
    } = this.props
    const {
      columns
    } = this.state

    let documents = this.props.mark ? this.props.mark.MarkDocuments : []
    /* let documents = []
    if (this.props.mark && this.props.mark.documentsReview) {
      for (let i = 0; i < this.props.mark.documentsReview.documentTypes.length; i++) {
        const documentType = this.props.mark.documentsReview.documentTypes[i]
        for (let d = 0; d < documentType.documents.length; d++) {
          const document = documentType.documents[d]
          documents.push({
            ...documentType,
            ...document
          })
        }
      }
    } */

    console.log(documents, 'fdffeff')

    return (
      <Modal
        open={open}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{modal: 'container-fluid'}}
        onClose={onClose}
      >
        <h3>Revisione documenti</h3>
        <div className="col-md-12" style={{minHeight: '350px', padding: '0'}}>
          <div className="col-md-12" style={{marginBottom: '10px'}}>
            {selectedRows.length > 0 && (
              <div>
                <a onClick={() => onDocumentDownloadClick(documents[selectedRows[0]])} className="btn-download-user">
                  Scarica Documento
                </a>
              </div>
            )}
          </div>

          <div style={{marginLeft: '0px', marginRight: '0px', minWidth: '500px', width: '100%'}}>
            {error ? (
              <span className="text-danger">{error}</span>
            ) : (
              <ReactTable
                minRows={10}
                loading={loading}
                noDataText={'Nessun Documento Presente'}
                className="-highlight no-horizontal-border"
                data={documents}
                showPagination={false}
                style={{maxHeight: '500px', minWidth: '500px'}}
                defaultPageSize={documents.length}
                loadingText="Caricamento in corso..."
                getTrGroupProps={(state, rowInfo, column) => {
                  const isActive = rowInfo && selectedRows.indexOf(rowInfo.index) !== -1
                  const activeStyle = {}

                  if (isActive) {
                    activeStyle.backgroundColor = '#2196F3'
                  }
                  return {
                    style: {
                      borderBottom: 0,
                      ...activeStyle
                    }
                  }
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                  const isActive = rowInfo && selectedRows.indexOf(rowInfo.index) !== -1
                  const activeStyle = {}
                  if (isActive) {
                    activeStyle.color = '#FFFFF'
                  }
                  return {
                    onClick: (e, handleOriginal) => {
                      if (!rowInfo) {
                        return
                      }
                      onRowSelected(rowInfo.index, rowInfo.original)
                    }
                  }
                }}
                columns={columns} />
            )}
          </div>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BackofficeDocumentsReview/BackofficeDocumentsReview.js